// RP transcriptions for every phoneme-card example word. "R?" = rhotic /r/ only in General American.
const LEX = {
  FOOT: 'f ʊ t', BOOK: 'b ʊ k', PUT: 'p ʊ t', FLEECE: 'f l iː s', SEE: 's iː', TREE: 't r iː', SHIP: 'ʃ ɪ p', SIT: 's ɪ t',
  FISH: 'f ɪ ʃ', BED: 'b e d', PEN: 'p e n', HELP: 'h e l p', CAT: 'k æ t', MAN: 'm æ n', APPLE: 'æ p ə l', CUP: 'k ʌ p',
  LOVE: 'l ʌ v', MUD: 'm ʌ d', HOT: 'h ɒ t', JOB: 'dʒ ɒ b', BOX: 'b ɒ k s', ABOUT: 'ə b aʊ t', SOFA: 's əʊ f ə',
  BANANA: 'b ə n ɑː n ə', CAR: 'k ɑː R?', FATHER: 'f ɑː ð ə R?', PALM: 'p ɑː m', SAW: 's ɔː', THOUGHT: 'θ ɔː t',
  DOOR: 'd ɔː R?', TWO: 't uː', FOOD: 'f uː d', BLUE: 'b l uː', BIRD: 'b ɜː R? d', WORD: 'w ɜː R? d', WORK: 'w ɜː R? k',
  FACE: 'f eɪ s', DAY: 'd eɪ', LATE: 'l eɪ t', TIME: 't aɪ m', RIGHT: 'r aɪ t', MY: 'm aɪ', BOY: 'b ɔɪ', VOICE: 'v ɔɪ s',
  JOIN: 'dʒ ɔɪ n', NOW: 'n aʊ', HOUSE: 'h aʊ s', DOWN: 'd aʊ n', GO: 'ɡ əʊ', NO: 'n əʊ', BOAT: 'b əʊ t',
  NEAR: 'n ɪə R?', HERE: 'h ɪə R?', BEER: 'b ɪə R?', SQUARE: 's k w eə R?', HAIR: 'h eə R?', CARE: 'k eə R?',
  CURE: 'k j ʊə R?', TOUR: 't ʊə R?', PURE: 'p j ʊə R?', TOP: 't ɒ p', HAPPY: 'h æ p i', BIN: 'b ɪ n', RIB: 'r ɪ b',
  BABY: 'b eɪ b i', TEN: 't e n', BUTTER: 'b ʌ t ə R?', DIN: 'd ɪ n', BAD: 'b æ d', LADDER: 'l æ d ə R?', BACK: 'b æ k',
  PICNIC: 'p ɪ k n ɪ k', GET: 'ɡ e t', BIG: 'b ɪ ɡ', EAGER: 'iː ɡ ə R?', CHURCH: 'tʃ ɜː R? tʃ', WATCH: 'w ɒ tʃ',
  NATURE: 'n eɪ tʃ ə R?', JUDGE: 'dʒ ʌ dʒ', AGE: 'eɪ dʒ', SOLDIER: 's əʊ l dʒ ə R?', FAN: 'f æ n', OFF: 'ɒ f',
  PHOTO: 'f əʊ t əʊ', VAN: 'v æ n', SAVE: 's eɪ v', EVERY: 'e v r i', THINK: 'θ ɪ ŋ k', THREE: 'θ r iː', BATH: 'b ɑː θ',
  THIS: 'ð ɪ s', MOTHER: 'm ʌ ð ə R?', BREATHE: 'b r iː ð', SUN: 's ʌ n', PRICE: 'p r aɪ s', ZOO: 'z uː', ROSE: 'r əʊ z',
  PLEASE: 'p l iː z', NATION: 'n eɪ ʃ ə n', VISION: 'v ɪ ʒ ə n', LEISURE: 'l e ʒ ə R?', BEIGE: 'b eɪ ʒ', HAT: 'h æ t',
  HOPE: 'h əʊ p', BEHIND: 'b ɪ h aɪ n d', SUMMER: 's ʌ m ə R?', NUN: 'n ʌ n', DINNER: 'd ɪ n ə R?', SING: 's ɪ ŋ',
  FINGER: 'f ɪ ŋ ɡ ə R?', LONG: 'l ɒ ŋ', LIGHT: 'l aɪ t', FULL: 'f ʊ l', RED: 'r e d', VERY: 'v e r i',
  AROUND: 'ə r aʊ n d', YES: 'j e s', BEAUTY: 'b j uː t i', MUSIC: 'm j uː z ɪ k', WET: 'w e t', AWAY: 'ə w eɪ',
  QUEEN: 'k w iː n',
};
const GA_WORD = { BATH: 'b æ θ', BANANA: 'b ə n æ n ə', OFF: 'ɔ f', LONG: 'l ɔ ŋ' };
const GA_MAP = { 'ɒ': 'ɑ', 'əʊ': 'oʊ', 'ɑː': 'ɑ', 'ɔː': 'ɔ', 'iː': 'i', 'uː': 'u', e: 'ɛ', 'ɪə': 'ɪ', 'eə': 'ɛ', 'ʊə': 'ʊ' };

export const transcribe = (word, dialect = 'RP') => {
  const w = String(word || '').toUpperCase().trim();
  const isGA = dialect !== 'RP';
  const raw = (isGA && GA_WORD[w]) || LEX[w];
  if (!raw) return null;
  const out = [];
  raw.split(' ').forEach((p) => {
    if (p === 'R?') {
      if (!isGA) return;
      const last = out[out.length - 1];
      if (last === 'ə') out[out.length - 1] = 'ɚ';
      else if (last === 'ɜ' || last === 'ɜː') out[out.length - 1] = 'ɝ';
      else out.push('r');
      return;
    }
    out.push(isGA ? (GA_MAP[p] || p) : p);
  });
  return out;
};

export const knownWord = (word) => !!LEX[String(word || '').toUpperCase().trim()];

export const dialectSymbol = (sym, dialect) => (dialect !== 'RP' && GA_MAP[sym]) || sym;
